import { useState, useEffect } from "react";
import Pin from "../Pin";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../hooks/useIsMobile";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 3000, min: 1201 },
    items: 7,
  },
  between: {
    breakpoint: { max: 1200, min: 1025 },
    items: 6,
  },
  largeDesktop: {
    breakpoint: { max: 1024, min: 769 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 768, min: 641 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 640, min: 485 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 484, min: 0 },
    items: 2,
  },
};

const UserAchievements = ({ seasons = [] }) => {
  const navigate = useNavigate();

  const isMobile = useIsMobile();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 2000);
  }, []);

  return (
    <div className={`${styles.cnt} ${mounted ? styles.ready : null}`}>
      <Carousel
        className={styles.slider}
        itemClass={styles.sliderItem}
        slidesToSlide={1}
        responsive={responsive}
      >
        {seasons.map((entry) => (
          <Pin
            smallFont={true}
            key={entry.Season}
            leftSideText={`${entry.Rank} місце`}
            topCaption={`${entry.Season}/${entry.Season + 1}`}
            rightSideText={entry.Points}
            width={isMobile ? 115 : 125}
            isAnimatedNumber={false}
            onClick={() => navigate(`/archived/${entry.Season}`)}
          />
        ))}
      </Carousel>{" "}
    </div>
  );
};

export default UserAchievements;
